import { render, staticRenderFns } from "./MarketCapArea.vue?vue&type=template&id=292581a2&scoped=true&"
import script from "./MarketCapArea.vue?vue&type=script&lang=js&"
export * from "./MarketCapArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "292581a2",
  null
  
)

export default component.exports